exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-laser-mdx": () => import("./../../../src/pages/laser.mdx" /* webpackChunkName: "component---src-pages-laser-mdx" */),
  "component---src-pages-metadata-mdx": () => import("./../../../src/pages/metadata.mdx" /* webpackChunkName: "component---src-pages-metadata-mdx" */),
  "component---src-pages-robotarm-mdx": () => import("./../../../src/pages/robotarm.mdx" /* webpackChunkName: "component---src-pages-robotarm-mdx" */)
}

